// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"rb_a","PostMenu__item--moderator":"rb_b","PostMenu__item--author":"rb_c"};